import { Toast } from "@homebound/beam";
import { PropsWithChildren } from "react";
import { DownloadTracker } from "src/components/DownloadTracker";
import { ErrorBoundary } from "src/components/ErrorBoundary";
import { LocalProdEnvironmentWarning } from "src/components/LocalProdEnvironmentWarning";
import { getStage } from "src/context";
import { useCurrentInternalUserQuery } from "src/queries/user.generated";
import { ImpersonationWarning, impersonationWarningStickyTopPx } from "./ImpersonationWarning";
import { QaEnvironmentWarning } from "./QaEnvironmentWarning";

/** Env warnings, impersonation banner, toast, and error boundary below the global nav. Shared by legacy and migrated routes. */
export function LoggedInPageWrapper(props: PropsWithChildren) {
  const { data } = useCurrentInternalUserQuery();
  const internalUserImpersonation = data?.internalUserImpersonation;
  const stage = getStage();

  return (
    <>
      {stage === "local-prod" && <LocalProdEnvironmentWarning />}
      {stage === "qa" && <QaEnvironmentWarning />}
      {internalUserImpersonation && (
        <ImpersonationWarning
          impersonatee={internalUserImpersonation.impersonatee}
          stickyTopPx={impersonationWarningStickyTopPx()}
        />
      )}
      <Toast />
      <DownloadTracker />
      <ErrorBoundary>{props.children}</ErrorBoundary>
    </>
  );
}
